var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[_c('add-highlight',{attrs:{"players":_vm.match.teams}})],1)],1),_c('v-row',[_c('v-col',[_c('match-highlights-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }